import type { ActivityFilters } from './types';

// Keep wire order as well as the legacy truthy-only serialization policy.
const filterKeys: (keyof ActivityFilters)[] = [
  'status',
  'workPath',
  'azureProject',
  'azureRepository',
  'source',
  'issueExternalId',
  'createdBy',
  'createdFrom',
  'createdToExclusive',
  'page',
  'limit',
  'mineOnly',
];
const listOnly = new Set<keyof ActivityFilters>(['createdBy', 'page', 'limit']);

export function activityFilterQuery(
  filters: ActivityFilters,
  target: 'list' | 'options',
): string {
  const params = new URLSearchParams();
  for (const key of filterKeys) {
    if (target === 'options' && listOnly.has(key)) continue;
    const value = filters[key];
    if (value) params.set(key, key === 'mineOnly' ? 'true' : String(value));
  }
  const query = params.toString();
  return query ? `?${query}` : '';
}
